import { useDispatch, useSelector } from "react-redux";
import "./ContactForm.css";
import { clearContactForm, selectContactBudget, selectContactEmail, selectContactName, selectContactProjectDetails, selectContactProjectType, selectFormStatus, setContactBudget, setContactEmail, setContactName, setContactProjectDetails, setContactProjectType, setFormStatus } from "./contactFormSlice";
import Select from "react-select";
import { useSubmitContactFormMutation } from "../../services/api";
import LoadingSpinner from "../../components/loadingSpinner/LoadingSpinner";

const projectTypeOptions = [
    { value: "inscriptionOrDesign", label: "Inscription or Design"},
    { value: "propWeapon", label: "Fantasy Prop Weapon"},
    { value: "miniature", label: "Character Miniature"},
    { value: "wholesale", label: "Wholesale Inquiry"},
    { value: "question", label: "General Question"},
    { value: "orderIssue", label: "Order Issue"}
];

const budgetRangeOptions = [
    { value: "Under $100", label: "Under $100"},
    { value: "$100 - $300", label: "$100 - $300"},
    { value: "$300 - 600", label: "$300 - $600"},
    { value: "Over $600", label: "Over $600"}
]

export default function ContactForm() {
    const dispatch = useDispatch();

    const [ submitContactForm, { isLoading: submitContactFormLoading}] = useSubmitContactFormMutation();

    const contactName = useSelector(selectContactName);
    const contactEmail = useSelector(selectContactEmail);
    const contactProjectType = useSelector(selectContactProjectType);
    const contactBudget = useSelector(selectContactBudget);
    const contactProjectDetails = useSelector(selectContactProjectDetails);
    const formStatus = useSelector(selectFormStatus);

    const handleContactNameChange = (event) => {
        dispatch(setContactName(event.target.value));
    }

    const handleContactEmailChange = (event) => {
        dispatch(setContactEmail(event.target.value));
    }

    const handleContactProjectTypeChange = (option) => {
        dispatch(setContactProjectType(option));
    }

    const handleContactBudgetChange = (option) => {
        dispatch(setContactBudget(option));
    }

    const handleContactProjectDetailsChange = (event) => {
        dispatch(setContactProjectDetails(event.target.value));
    }

    const handleFormSubmit = async (event) => {
        event.preventDefault();

        if (!contactName) {

        }

        const formData = {
            contactName,
            contactEmail,
            contactProjectType: contactProjectType.label,
            contactBudget: contactBudget.label,
            contactProjectDetails
        }

        const response = await submitContactForm(formData);

        console.log(response);

        if (response.data.message === 'Submission received.') {
            dispatch(clearContactForm());
            dispatch(setFormStatus('success'));
        } else {
            dispatch(setFormStatus(response.data.status));
        }
    }

    if (formStatus === 'pending') {
        return (
            <form className="contactForm" onSubmit={handleFormSubmit}>
                <div className="row1">
                    <label>
                        <p>NAME</p>
                        <input 
                            name="contactName" 
                            value={contactName} 
                            onChange={handleContactNameChange} 
                            placeholder="Your name" 
                            disabled={submitContactFormLoading}
                            required
                        />
                    </label>
                    <label>
                        <p>EMAIL</p>
                        <input 
                            name="contactEmail" 
                            type="email" 
                            value={contactEmail} 
                            onChange={handleContactEmailChange} 
                            placeholder="you@example.com" 
                            disabled={submitContactFormLoading}
                            required 
                        />
                    </label>
                </div>
                <div className="row2">
                    <label>
                        <p>PROJECT TYPE</p>
                        <Select
                            className="react-select-container"
                            classNamePrefix={'react-select'}
                            options={projectTypeOptions}
                            value={contactProjectType}
                            onChange={handleContactProjectTypeChange} 
                        />
                    </label>
                    <label>
                        <p>BUDGET RANGE</p>
                        <Select
                            className="react-select-container"
                            classNamePrefix={'react-select'}
                            options={budgetRangeOptions}
                            value={contactBudget}
                            onChange={handleContactBudgetChange} 
                        />    
                    </label>
                </div>
                <label>
                    <p>PROJECT DETAILS</p>
                    <textarea 
                        className="contactProjectDetails" 
                        value={contactProjectDetails} 
                        onChange={handleContactProjectDetailsChange} 
                        placeholder="Describe your project, inspiration, dimensions, materials, or references..." 
                        rows="4" 
                        disabled={submitContactFormLoading}
                        required
                    />
                </label>
                <div className="bottom-row">
                    <p className="projectDetailsHelpText">Include links, reference art, or convention deadlines in your message for faster commission estimates.</p>
                    <button disabled={submitContactFormLoading}>Send Inquiry</button>
                    {submitContactFormLoading ? <LoadingSpinner/> : ''}
                </div>
            </form>
        )
    } else if (formStatus === 'success') {
        return (
            <div className="contactForm">
                <h3>Submission Received!</h3>
                <p>Thank you for getting in touch. Someone will address your inquiry soon.</p>
            </div>
        )
    } else {
        return (
            <div className="contactForm">
                <h3>We're Sorry!</h3>
                <p>There was a problem. Please reload the page and try again.</p>
            </div>
        )
    }

    
}